import ThemeButton from "./ThemeButton";

export default ThemeButton;
export { ThemeButton };
